var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7165 6.17479C15.9494 7.40768 15.9494 9.40658 14.7165 10.6395C13.4836 11.8724 11.4847 11.8724 10.2518 10.6395C9.01893 9.40658 9.01893 7.40768 10.2518 6.17479C11.4847 4.9419 13.4836 4.9419 14.7165 6.17479Z",
    stroke: "#F75E6E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.429 15.009C15.2546 14.5398 13.8768 14.2812 12.4845 14.2812C8.82483 14.2812 5.25195 16.0596 5.25195 18.7944V19.6984C5.25195 20.1975 5.65698 20.6025 6.15602 20.6025H14.666",
    stroke: "#F75E6E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8123 23.3376C16.3162 23.3376 14.292 21.3143 14.292 18.8172C14.292 16.3726 16.3714 14.2942 18.816 14.2969C21.3112 14.2987 23.3327 16.322 23.3327 18.8172C23.3327 21.3134 21.3094 23.3376 18.8123 23.3376Z",
    fill: "#F75E6E",
    stroke: "#F75E6E",
    strokeWidth: 1.3561,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.dab6993fd38a1194621bead8a18e440f.svg";
export { ForwardRef as ReactComponent };